export const BRANCHES = [
  "Konattu Digi Home – Changanacherry",
  "Konattu Digi Smart – Pampady",
  "Konattu Smart Home – Mukkuttuthara",
  "Konattu Agencies – Mallapally",
  "Konattu InHome – Podimattom",
  "Konattu Hypermart – Mundakayam",
  "Konattu ExpressMart – Manimala",
  "Emilia – Kottayam",
  "Konattu Digi Plaza – Ponkunnam",
  "Konattu Smart Home – Kaduthuruthy",
  "Konattu Agencies – Plackalpady",
  "Konattu Digi Palace – Karukachal",
  "Konattu InHome – Madukkumoodu",
  "Konattu Hypermart – Thodupuzha",
  "Konattu Furniture – Karukachal",
  "Emilia – Changanacherry",
  "Konattu – Myladi",
];

export const DEFAULT_PRODUCTION_URL = "https://luckydraw.konattugroup.com";

export function maskPhone(p) {
  if (!p) return "";
  return "••••••" + p.slice(-4);
}

export function formatIST(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString("en-IN", {
      hour: "2-digit", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata"
    });
  } catch { return ""; }
}
